import React from "react";
import LightTheme from "./LightTheme";
export type ThemeType = "light" | "dark";

// Dark mode is disabled for now, so only the light theme is rendered.
// DarkTheme is intentionally not imported: its require() of dark.less gets pulled
// into the production CSS bundle even when it never renders, and overrides light.less.
// Re-enabling dark mode needs a theme loader that keeps dark.less out of the main bundle.
const ThemeSelector: React.FC = ({ children }) => {
  return (
    <>
      <LightTheme />
      {/* Render children immediately! */}
      {children}
    </>
  );
};

export default ThemeSelector;
